import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { api, JobApplication } from '../services/api';

interface JobApplicationsListProps {
  apiUrl: string;
  audience: string;
}

const JobApplicationsList: React.FC<JobApplicationsListProps> = ({ apiUrl, audience }) => {
  const [applications, setApplications] = useState<JobApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        // Make sure we have a token before making the API call
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: audience, // Value from config.json
            scope: 'read', // Scope that exists for the API being called. You can create these through the Auth0 Management API or through the Auth0 Dashboard in the Permissions view of your API.
          }
        });
        //await getAccessTokenSilently();
        const data = await api.getJobApplications(apiUrl, token);
        setApplications(data);
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching applications from ${apiUrl}:`, err);
        setError('Failed to load job applications. Please try again later.');
        setLoading(false);
      }
    };

    fetchApplications();
  }, [apiUrl, audience, getAccessTokenSilently]);

  const handleApplicationClick = (id: string) => {
    navigate(`/applications/${id}`);
  };

  if (loading) {
    return <div className="loading">Loading job applications...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div>
      <h2>Your Job Applications</h2>

      {applications.length === 0 ? (
        <p>You haven't added any job applications yet.</p>
      ) : (
        <div className="job-list">
          {applications.map(app => (
            <div 
              key={app.id} 
              className="card job-card"
              onClick={() => handleApplicationClick(app.id)}
            >
              <h3>{app.position}</h3>
              <p><strong>Company:</strong> {app.company}</p>
              <p><strong>Date Applied:</strong> {new Date(app.dateApplied).toLocaleDateString()}</p>
              <p>
                <span className={`status-badge status-${app.status}`}>
                  {app.status}
                </span>
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default JobApplicationsList;
